const obtenerTercero = `/api-flujo-digital/persona/obtener`;

const newObtenerTercero = `/api-vida-contigo/vc/tercero/obtener`;
const validarTercero = `/api-vida-contigo/vc/tercero/validar`;

const obtenerPlanes = `/api-vida-contigo/vc/cotizacion/crear`;
const seleccionarPlan = `/api-vida-contigo/vc/cotizacion/gestionar`;
const agregarTercero = `/api-vida-contigo/vc/emision/terceros`;

const dpsQuestions = `/api-vida-contigo/vc/emision/suscripcion`;
const registerLead = `/leads/registrar`;

const enviarCorreo = `/utilitarios/correo/enviar`;
const obtenerProvincias = `/utilitarios/ubigeo/provincia`;
const obtenerDepartamentos = `/utilitarios/ubigeo/departamento`;
const obtenerDistritos = `/utilitarios/ubigeo/distrito`;

const registerAuditoria = `/api-auditoria-venta-digital/crear`;
const registerAuditoriaDet = `/api-auditoria-venta-digital/detalle/crear`;

const validationPoliza = '/api-vida-contigo/vc/datos/validacion';
const obtenerValores = '/api-vida-contigo/vc/cotizacion/valores';
const downloadPDF = '/api-vida-contigo/vc/pdf/subida';

const pagoSession = '/api-canal-pago/generar/sesion';

const createDigitalId = '/autenticacion-personas/cookies';

const obtenerAtributoValor = '/api-vida-contigo/vc/valores/listar';

const obtainOneStep = '/api-vida-contigo/vc/one-step/cotizaciones/obtener';

const getRelationship = '/api-vida-contigo/vc/parametro';

/* Seguro de Viajes */

const obtenerDestinos = '/api-vida-contigo/vc/paises-destino/listar'

/* Canal Cross */

const registrarEmision = '/flujos-web/emisiones/trigger';
const getJobs = '/ocupaciones/listar';
const downloadQuote = '/flujos-web/cross/documentos/generar';

/* Vida Endosable */
const financialEntities = '/entidades-financieras';
const quoteVe = '/cotizador';
const endorseQuoteVE = '/cotizador/endosar';
const obtenerAtributoValorVe = '/reglas-negocio';
const baseSuscription = '/suscripcion';
const suscriptionQuestions = '/suscripcion/{caseId}/preguntas';

/* Contentstack */

const getEntries = '/entries/{idEntry}/product-type/{productType}';
const getContentType = '/content/{contentTypeId}';

export default {
	seleccionarPlan,
	dpsQuestions,
	agregarTercero,
	obtenerTercero,
	obtenerPlanes,
	registerLead,
	enviarCorreo,
	obtenerDepartamentos,
	obtenerProvincias,
	obtenerDistritos,
	registerAuditoria,
	registerAuditoriaDet,
	validationPoliza,
	obtenerValores,
	downloadPDF,
	pagoSession,
	createDigitalId,
	obtenerAtributoValor,
	validarTercero,
	newObtenerTercero,
	obtainOneStep,
	obtenerDestinos,
	registrarEmision,
	getJobs,
	downloadQuote,
	getRelationship,
	financialEntities,
	quoteVe,
	endorseQuoteVE,
	obtenerAtributoValorVe,
	baseSuscription,
	suscriptionQuestions,
	getContentType,
	getEntries,
};
